// Module
var code = `<div class="svc-question__adorner" data-bind="css: rootCss(), attr: { 'data-sv-drop-target-survey-element': element.name }, event: { mouseover: function(m, e) { hover(e, \$element); }, mouseleave: function(m, e) { hover(e, \$element); } }">
  <!-- ko if: question.isInteractiveDesignElement -->
  <div class="svc-question__content" data-bind="click: koSelect, key2click, clickBubble: false, css: css()">
    <div class="svc-question__drop-indicator svc-question__drop-indicator--left"></div>
    <div class="svc-question__drop-indicator svc-question__drop-indicator--right"></div>
    <div class="svc-question__drop-indicator svc-question__drop-indicator--top"></div>
    <div class="svc-question__drop-indicator svc-question__drop-indicator--bottom"></div>
    <!-- ko if: allowDragging -->
    <div class="svc-question__drag-area" data-bind="visible:allowDragging, event: {pointerdown: (model, event)=>{onPointerDown(event)}}">
      <!-- ko component: { name: 'sv-svg-icon', params: { css: 'svc-question__drag-element', iconName: 'icon-drag-area-indicator_24x16', size: 'auto' } } -->
      <!-- /ko -->
    </div>
    <!-- /ko -->
    <div class="svc-widget__content">
      <!-- ko component: { name: 'sv-template-renderer', params: { componentData: null, templateData: templateData } } -->
      <!-- /ko -->
    </div>
    <!-- ko if: isEmptyElement -->
    <div class="svc-panel__placeholder_frame">
      <div class="svc-panel__placeholder" data-bind="text: placeholderText"></div>
    </div>
    <!-- /ko -->

    <div class="svc-question__content-actions">
      <!-- ko component: { name: 'sv-action-bar', params: { model: actionContainer } } -->
      <!-- /ko -->
    </div>
  </div>
  <!-- /ko -->
  <!-- ko ifnot: question.isInteractiveDesignElement -->
  <!-- ko component: { name: 'sv-template-renderer', params: { componentData: null, templateData: templateData } } -->
  <!-- /ko -->
  <!-- ko if: isEmptyElement -->
  <div class="svc-panel__placeholder_frame">
    <div class="svc-panel__placeholder" data-bind="text: placeholderText"></div>
  </div>
  <!-- /ko -->
  <!-- /ko -->
</div>`;
// Exports
export default code;